import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useUrlParams } from "./useUrlParams";
import { ENTITY, EXPERIENCE_ACTIVITY } from "../constants";
import { getCurrentExperience, updateExperienceActivityOpened } from "../store/actions";
import { currentExperienceSelector } from "../store/selectors";

export function useCurrentExperienceData(props) {
  const { hookEnabled } = props;

  const dispatch = useDispatch();
  const timer = useRef(null);
  const params = useUrlParams();
  const { propertyId, experienceId, userId, tabStatus } = params;
  const { experience } = useSelector(currentExperienceSelector);

  const shareId = new URLSearchParams(location.search).get("shareId");

  const fetchCurrentExperience = () => {
    if (timer.current) {
      clearTimeout(timer.current);
    }

    timer.current = setTimeout(() => {
      dispatch(getCurrentExperience(params, { ...(shareId && { shareId }) }));
    }, 300);
  };

  useEffect(() => {
    if (hookEnabled) {
      fetchCurrentExperience();
    }
  }, [propertyId, experienceId, userId, hookEnabled]);

  useEffect(() => {
    if (hookEnabled) {
      const listener = ({ detail }) => {
        const { instances, options = {} } = detail;

        if (
          instances.includes(+experienceId) ||
          (options.propertyId === +propertyId && options.experienceId === +experienceId)
        ) {
          fetchCurrentExperience();
        }
      };

      const entities = [ENTITY.EXPERIENCE, ENTITY.EXPERIENCE_CONTACT, ENTITY.FAVORITE, ENTITY.EXPERIENCE_CONTENT_TYPE];

      entities.forEach((entity) => document.addEventListener(entity, listener));
      return () => entities.forEach((entity) => document.removeEventListener(entity, listener));
    }
  }, [propertyId, experienceId, userId, tabStatus, hookEnabled]);

  useEffect(() => {
    if (shareId && experience.activity === EXPERIENCE_ACTIVITY.UNOPENED) {
      dispatch(updateExperienceActivityOpened(propertyId, experience, EXPERIENCE_ACTIVITY.OPENED));
    }
  }, [propertyId, shareId, experience.activity]);
}
